"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _react2 = require("@chakra-ui/react");

var _Youtube = require("../../helpers/Youtube");

var _VideoYoutube = _interopRequireDefault(require("../../components/VideoYoutube"));

var _RendererContext = require("../RendererContext");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

/**
 * @typedef {object} Props
 * @property {import("../../../types/blocks").BlockVideo} block
 */

/**
 * @param {Props} props
 */
var BlockVideoChakra = function BlockVideoChakra(_ref) {
  var _block$content$intl$l, _block$content$intl$l2, _block$content$intl$d;

  var block = _ref.block;

  var _useContext = (0, _react.useContext)(_RendererContext.RendererContext),
      document = _useContext.document,
      language = _useContext.language;

  var src = (_block$content$intl$l = (_block$content$intl$l2 = block.content.intl[language.key]) == null ? void 0 : _block$content$intl$l2.source) != null ? _block$content$intl$l : (_block$content$intl$d = block.content.intl[document.language]) == null ? void 0 : _block$content$intl$d.source;
  var idVideoYoutube = (0, _Youtube.getYoutubeId)(src);
  return __jsx(_react["default"].Fragment, null, idVideoYoutube ? __jsx(_VideoYoutube["default"], {
    id: idVideoYoutube,
    showControls: block.content.controls
  }) : __jsx("video", {
    width: "100%",
    controls: block.content.controls,
    autoPlay: block.content.autoplay
  }, __jsx("source", {
    src: src
  }), __jsx(_react2.Text, null, "Your browser does not support the video tag")));
};

var _default = BlockVideoChakra;
exports["default"] = _default;